import i18n from "../i18n";

const TAG_TO_KEY = {
  "Credit clients": "creditClients",
  "Sales projection": "salesProjection",
  "Partner lending": "partnerLending",
  "Pending checks": "pendingChecks",
  OTHER_INCOME: "otherIncome",
  "Other incomes": "otherIncomes",
  TOTAL_INCOME: "incomeCategory",
  Fees: "fees",
  Taxes: "taxes",
  Salaries: "salaries",
  "Expense report": "expenseReport",
  HUMAN_RESOURCES_EXPENSES: "humanResourcesExpenses",
  Rent: "rent",
  trade_credit: "tradeCredit",
  Services: "services",
  Checks: "checks",
  "Outsourcing backoffice": "outsourcingBackoffice",
  "Other providers": "otherProviders",
  "Operational providers": "operationalProviders",
  "Administration providers": "administrationProviders",
  PROVIDERS_TO_PAY: "providersToPay",
  "Overcharge line": "overchargeLine",
  "Credit letters": "creditLetters",
  Withdrawals: "withdrawals",
  FINANCING: "financing",
  "Foreign providers": "foreignProviders",
  Imports: "imports",
  "F-29": "f29",
  "F-29 postponed": "f29Postponed",
  "F-22": "f22",
  "F-50": "f50",
  IMPORTS: "importsCategory",
  TAXES: "taxesCategory",
  outflows: "totalExpenses",
  inflows: "totalIncome",
  netInflow: "netCashflow",
  initialBalance: "initialBalance",
  closingBalance: "closingBalance",
  "Credit cards": "creditCards",
  "Key Providers": "keyProviders",
  "Financial Instruments": "financialInstruments",
  "Trade agreements": "tradeAgreements",
  comex: "comex",
  bullet: "bullet",
};

const SPANISH_TO_KEY = {
  "Clientes a crédito": "creditClients",
  "Proyección de ventas": "salesProjection",
  "Aportes / Préstamos socios": "partnerLending",
  "Cheques por cobrar": "pendingChecks",
  "Otros ingresos": "otherIncome",
  "Otras fuentes": "otherIncomes",
  Ingresos: "incomeCategory",
  Honorarios: "fees",
  Imposiciones: "taxes",
  Sueldos: "salaries",
  Rendiciones: "expenseReport",
  "Gastos RRHH": "humanResourcesExpenses",
  Arriendos: "rent",
  "Cuotas de crédito": "tradeCredit",
  "GGCC y servicios generales": "services",
  "Cheques por pagar": "checks",
  "Otros proveedores": "otherProviders",
  "Proveedores operacionales": "operationalProviders",
  "Prov. Operacionales": "operationalProviders",
  "Proveedores administración": "administrationProviders",
  "Prov. Administrativos": "administrationProviders",
  "Proveedores por pagar": "providersToPay",
  "Línea de sobregiro": "overchargeLine",
  "Cartas de crédito": "creditLetters",
  "Retiros / devoluciones socios": "withdrawals",
  Financiamiento: "financing",
  "Proveedores extranjeros": "foreignProviders",
  "Prov. importación / Agencia aduana": "imports",
  "Declaración F-29 IVA": "f29",
  "Declaración F-29 Postergado": "f29Postponed",
  "Declaración F-22 Renta": "f22",
  "Declaración F-50": "f50",
  Importaciones: "importsCategory",
  Impuestos: "taxesCategory",
  "Egresos totales": "totalExpenses",
  "Ingresos totales": "totalIncome",
  "Variación de caja": "netCashflow",
  "Saldo inicial": "initialBalance",
  "Saldo final": "closingBalance",
  "Tarjeta de crédito": "creditCards",
  "Proveedores clave": "keyProviders",
  "Instrumentos Financieros": "financialInstruments",
  "Acuerdos Comerciales": "tradeAgreements",
  Comex: "comex",
  Bullet: "bullet",
  Egresos: "expenseCategory",
};

export function getCashflowLabelKey(value) {
  if (!value) return null;
  return TAG_TO_KEY[value] || SPANISH_TO_KEY[value] || null;
}

export function translateCashflowLabel(value) {
  if (!value) return value;
  const key = getCashflowLabelKey(value);
  if (key) return i18n.t(`finance:cashflowTable.labels.${key}`);
  return value;
}

export function isOpeningBalanceLabel(label) {
  return getCashflowLabelKey(label) === "initialBalance";
}
